module.exports = __webpack_public_path__ + "img/lijiang02.e617de1d.png";